/* ═══════════════════════════════════════════════════════════════════════
   ISOFIN — Teilmengen-Warnung Produktseite (v358, 2026-07-03)
   ───────────────────────────────────────────────────────────────────────
   Wenn auf der Produktseite (Einzelflaschen-Verkauf, Variante 55868037857653)
   WENIGER ALS 4 FLASCHEN (= unter 1 Meter Wand, 25 cm/Flasche) gekauft
   werden sollen UND der Warenkorb noch keine Isofin-Flaschen enthält,
   erscheint eine Warnung vor Teilbehandlung: hohes Risiko, dass die
   Feuchtigkeit die kurze Sperre seitlich umwandert (Text adaptiert vom
   Produktseiten-Abschnitt »Teilbehandlungen funktionieren nicht«).

   Optionen im Popup:
   • PRIMÄR  „Meine Wand berechnen →"  → /pages/kalkulator
   • SEKUNDÄR „Ich bin mir bewusst — trotzdem X Flasche(n) bestellen"
     → ursprünglicher Klick wird durchgelassen (Add läuft normal weiter)
   • Schließen/Overlay → Abbruch (nichts passiert)

   Abgefangen werden BEIDE Kaufwege: [data-iso-add-to-cart] (Warenkorb)
   und [data-iso-buy-link] (Direkt-Kauf). KEINE Warnung bei Menge ≥ 4
   oder wenn bereits Flaschen (Paket ODER Einzel) im Warenkorb liegen
   (Nachbesteller!).

   WICHTIG: Dieses Script wird OHNE defer geladen (parse-zeitig), damit
   sein document-CAPTURE-Listener VOR dem deferred iso-cart-drawer
   (wireGlobalAddToCart) registriert ist und den Klick zuerst sieht.
   ═══════════════════════════════════════════════════════════════════════ */
(function (w, d) {
  "use strict";
  if (w.__ISO_TEILMENGE__) return;
  w.__ISO_TEILMENGE__ = 1;

  var EINZEL_ID = "55868037857653";
  var PAKET_ID = "55049427616117";
  var KALK_URL = "/pages/kalkulator";
  var WARN_UNTER = 4;          /* Warnung bei weniger als 4 Flaschen (< 1 m Wand) */
  var CM_PRO_FLASCHE = 25;

  function track(ev, data) {
    /* A6: ohne step landet das Event auf /goal und faelscht den Kauf-Zaehler "converted". */
    try { if (typeof w.logr3Track === "function") w.logr3Track(ev, Object.assign({ step: true }, data || {})); } catch (e) {}
  }

  /* ── Flaschen im Warenkorb cachen (Klick-Handler muss synchron sein) ── */
  var cartBottles = 0;
  function refreshCart() {
    try {
      fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || !c.items) return;
          var n = 0;
          for (var i = 0; i < c.items.length; i++) {
            var vid = String(c.items[i].variant_id || c.items[i].id || "");
            if (vid === EINZEL_ID || vid === PAKET_ID) n += (parseInt(c.items[i].quantity, 10) || 0);
          }
          cartBottles = n;
        }).catch(function () {});
    } catch (e) {}
  }
  refreshCart();
  ["cart:updated", "cart:refresh", "product:added", "isofin:cartUpdated"].forEach(function (ev) {
    d.addEventListener(ev, refreshCart);
  });

  function getQty() {
    var inp = d.getElementById("iso-qty-input");
    if (!inp) return null;
    var v = parseInt(inp.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    return v;
  }

  /* ── Popup ── */
  var CSS = "" +
    ".itw-ov{position:fixed;inset:0;background:rgba(17,17,17,.5);z-index:2147483300;display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;visibility:hidden;transition:opacity .18s}" +
    ".itw-ov.is-on{opacity:1;visibility:visible}" +
    ".itw-card{background:#fff;border-radius:16px;max-width:440px;width:100%;padding:24px 22px 20px;box-shadow:0 18px 50px rgba(0,0,0,.25);font-family:Rubik,-apple-system,sans-serif;position:relative;transform:translateY(8px);transition:transform .18s}" +
    ".itw-ov.is-on .itw-card{transform:translateY(0)}" +
    ".itw-x{position:absolute;top:12px;right:12px;width:36px;height:36px;border:0;border-radius:50%;background:#f2f1ef;color:#444;font-size:17px;line-height:1;cursor:pointer}" +
    ".itw-title{margin:0 36px 10px 0;font-size:19px;font-weight:700;color:#1a1a1a;line-height:1.3}" +
    ".itw-text{margin:0 0 16px;font-size:15.5px;line-height:1.6;color:#3a3a3a}" +
    ".itw-text strong{color:#1a1a1a}" +
    ".itw-calc{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;box-sizing:border-box;padding:15px 18px;background:#D6001C;border:none;border-radius:12px;color:#fff !important;font-size:16px;font-weight:700;text-decoration:none;text-align:center;cursor:pointer;font-family:inherit}" +
    ".itw-calc:hover{background:#B8001A}" +
    ".itw-proceed{display:block;width:100%;box-sizing:border-box;margin:10px 0 0;padding:13px 16px;background:#fff;border:1px solid #d6d3ce;border-radius:12px;color:#6b6b6b;font-size:14.5px;font-weight:600;cursor:pointer;font-family:inherit}" +
    ".itw-proceed:hover{border-color:#aaa;color:#444}";

  function injectCSS() {
    if (d.getElementById("itw-css")) return;
    var s = d.createElement("style");
    s.id = "itw-css";
    s.textContent = CSS;
    d.head.appendChild(s);
  }

  var ovEl = null;
  function buildPopup() {
    if (ovEl) return;
    injectCSS();
    ovEl = d.createElement("div");
    ovEl.className = "itw-ov";
    ovEl.setAttribute("role", "dialog");
    ovEl.setAttribute("aria-modal", "true");
    ovEl.setAttribute("aria-label", "Hinweis zur Teilbehandlung");
    ovEl.innerHTML = "" +
      '<div class="itw-card">' +
      '<button type="button" class="itw-x" aria-label="Schließen">✕</button>' +
      '<p class="itw-title" id="itw-title"></p>' +
      '<p class="itw-text" id="itw-text"></p>' +
      '<a class="itw-calc" href="' + KALK_URL + '">Meine Wand berechnen <span aria-hidden="true">→</span></a>' +
      '<button type="button" class="itw-proceed" id="itw-proceed"></button>' +
      "</div>";
    d.body.appendChild(ovEl);

    function close(reason) {
      ovEl.classList.remove("is-on");
      if (reason) track("teilmenge_warn_close", { via: reason });
    }
    ovEl.addEventListener("click", function (e) { if (e.target === ovEl) close("overlay"); });
    ovEl.querySelector(".itw-x").addEventListener("click", function () { close("x"); });
    d.addEventListener("keydown", function (e) { if (e.key === "Escape" && ovEl.classList.contains("is-on")) close("esc"); });
    ovEl.querySelector(".itw-calc").addEventListener("click", function () {
      track("teilmenge_warn_calc_click", {});
    });
    ovEl.querySelector(".itw-proceed").addEventListener("click", function () {
      track("teilmenge_warn_proceed", { qty: pendingQty });
      ovEl.classList.remove("is-on");
      var btn = pendingBtn;
      pendingBtn = null;
      if (btn) {
        w.__ISO_TEILMENGE_OK__ = true;   /* nächsten Klick durchlassen */
        btn.click();
      }
    });
  }

  var pendingBtn = null, pendingQty = 1;
  function openPopup(btn, qty) {
    buildPopup();
    pendingBtn = btn;
    pendingQty = qty;
    var cm = qty * CM_PRO_FLASCHE;
    var fl = qty === 1 ? "eine Flasche" : qty + " Flaschen";
    var flBtn = qty === 1 ? "1 Flasche" : qty + " Flaschen";
    d.getElementById("itw-title").textContent = "⚠️ Nur " + fl + " bestellen?";
    d.getElementById("itw-text").innerHTML =
      (qty === 1 ? "Eine Flasche reicht" : qty + " Flaschen reichen") +
      " für rund <strong>" + cm + "&nbsp;Zentimeter</strong> Wand. Bei Abschnitten unter einem Meter ist das Risiko hoch, dass die kapillare Feuchtigkeit die kurze Sperre <strong>seitlich umwandert</strong> und weiter ins Mauerwerk aufsteigt. Bei der Ersthydrophobierung gilt deshalb: <strong>immer die gesamte Wand absperren</strong>.";
    d.getElementById("itw-proceed").textContent = "Ich bin mir bewusst — trotzdem " + flBtn + " bestellen";
    track("teilmenge_warn_shown", { qty: qty, cartBottles: cartBottles });
    ovEl.classList.add("is-on");
  }

  /* ── Capture-Interceptor (läuft vor Drawer/Section-Handlern) ── */
  d.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-iso-add-to-cart="' + EINZEL_ID + '"], [data-iso-buy-link]');
    if (!btn) return;
    if (!d.getElementById("iso-qty-input")) return;      /* nur Produktseite mit Stepper */
    if (w.__ISO_TEILMENGE_OK__) { w.__ISO_TEILMENGE_OK__ = false; return; }
    var qty = getQty();
    if (qty >= WARN_UNTER) return;                       /* Warnung nur unter 4 Flaschen (< 1 m) */
    if (cartBottles > 0) return;                         /* Nachbesteller nicht nerven */
    e.preventDefault();
    e.stopImmediatePropagation();
    openPopup(btn, qty);
  }, true);

})(window, document);
